<template >
        <span class="bgrndinfo" :style="backgroundStyle">
<!--                 <div style="float: right; margin-top:23px;">
                <a href="/sample.html">
                <el-tooltip class="item" effect="dark" :content="$t('menu.samples')" placement="bottom" :hide-after="3000">
                <img src="../../static/images/muster.png" alt="StruViMan graphic"/></el-tooltip></a>
                </div> -->
    
                <div>
                <h2>StruViMan</h2>
                <h3>Structural Visualization of Manuscripts</h3>
                </div>
    
                <div>                  

                  <p>StruViMan is a freely available tool to get a visual overview of the structure of manuscripts. Old codices are complex objects and the availability of digital images and/or metadata is often not sufficient to quickly grasp the structural properties. The diachronic dimension plays an important role here (multiple production layers, reconstruction of past strata). StruViMan can break down the structure according to two different criteria (e.g. production units, content elements).</p>

                  <p>The tool was developed at the Ludwig-Maximilians-Universität Munich in connection with the ERC project "Paratexts of the Bible (ParaTexBib)". It was funded by a Proof of Concept Grant (2017-2018, Grant No. 737621).</p>
    
                <p>The tool is used on the site <a href="https://www.manuscripta-biblica.org" target="_blank">www.manuscripta-biblica.org</a> and on the site <a href="https://pinakes.irht.cnrs.fr/" target="_blank">pinakes.irht.cnrs.fr/</a>. It is open for further applications.</p>
                
                <p>For demonstration purposes, a list of manuscripts can be found <a href="/sample.html"> here</a>.</p>

                <p>Technical information on use can be found below under "Information &amp; Help". For further explanations, see the article <a href="https://doi.org/10.1515/opth-2019-0009" target="_blank"> here</a>.</p>
                
                </div>
              </span>
</template>

<script >

export default {
    name: 'VStartInfoEn',
    props: {
        backgroundStyle: {
            default: ''
        }
    }
}

</script>




// WEBPACK FOOTER //
// src/components/VStartInfoEn.vue